import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Panel from './panel'
import Teams from './teams'
import Games from './games'
import Players from './players'
import Standings from './standings'
import Payments from './payments'
import LeagueForm from '../leagues/forms/league-form'

const League = (props) => {
  const {data, logo, teams, games, schedule, currentTab} = props
  const [shortened, setShortened] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const showTeams = currentTab == 'Teams'
  const showGames = currentTab == 'Games'
  const showPlayers = currentTab == 'Players'
  const showStandings = currentTab == 'Standings'
  const showPayments = currentTab == 'Payments'

  const changeTab = (value) => {
    setShortened(false)
    props.changeTab(value)
  }

  const onUpdateData = (data) => {
    props.updateData(data)
    setShowForm(false)
  }

  const onDeleteTeam = (id) => {
    props.deleteTeam(id)
    setShortened(false)
  }

  const onUpdateTeam = (team) => {
    props.updateTeam(team)
    setShortened(false)
  }

  const onUpdateGame = (game) => {
    props.updateGame(game)
    setShortened(false)
  }

  const onCloseLeague = (e) => {
    e.stopPropagation()
    if (window.confirm('Are you sure you want to close this league?')) {
      props.closeLeague(data.id)
    }
  }

  return <div className='league-content'>
    <img className='league-img' src={data.photo_url} />
    <a className='league-back' href='/admins/leagues'><img src='/images/leagues/back.png' /></a>
    <img className='company-logo' src={logo} />
    <div className='league-name' onClick={() => setShowForm(true)} title={data.name}>
      ✎&nbsp;{data.name}
    </div>
    <button
      className={'close-league' + (shortened ? ' shortened' : '')}
      disabled={data.closed}
      onClick={onCloseLeague}
      title={data.closed ? 'This League has been closed' : 'Close this league'}
    >
      Close
    </button>
    <Panel shortened={shortened} currentTab={currentTab} changeTab={changeTab} />
    { showForm && <LeagueForm id={data.id} onClose={() => setShowForm(null)} onUpdate={onUpdateData} /> }
    { showTeams && 
      <Teams
        teams={teams}
        league={data}
        locationName={data.location_name}
        shortened={shortened}
        onAddTeam={props.addTeam}
        onDeleteTeam={onDeleteTeam}
        onUpdateTeam={onUpdateTeam}
        onShorten={(value) => setShortened(value)}
      />
    }
    { showGames &&
      <Games
        league={data}
        games={games}
        schedule={schedule}
        shortened={shortened}
        onCreateSchedule={props.createSchedule}
        onCreateGames={props.createGames}
        onUpdateGame={onUpdateGame}
        onShorten={(value) => setShortened(value)}
      />
    }
    { showPlayers && <Players league={data} teams={teams} /> }
    { showStandings && <Standings league={data} /> }
    { showPayments && <Payments league={data} /> }
  </div>
}

League.propTypes = {
  data: PropTypes.object.isRequired,
  teams: PropTypes.array.isRequired,
  games: PropTypes.array.isRequired,
  schedule: PropTypes.object,
  currentTab: PropTypes.string.isRequired,
  changeTab: PropTypes.func.isRequired,
  updateData: PropTypes.func.isRequired,
  addTeam: PropTypes.func.isRequired,
  deleteTeam: PropTypes.func.isRequired,
  updateTeam: PropTypes.func.isRequired,
  createSchedule: PropTypes.func.isRequired,
  createGames: PropTypes.func.isRequired,
  updateGame: PropTypes.func.isRequired
}

export default League
